<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { RevenueEditorFormSubmitEventPayload, RevenueEditorViewModel } from '@Quest/Financials/Revenues/Components/RevenueEditor';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class RevenueEditor extends Vue
    {
        get vm(): RevenueEditorViewModel { return this.$props.viewModel as RevenueEditorViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get confirmButtonLabel(): string { return this.vm.confirmButtonLabel; }
        get title(): string { return this.vm.title; }

        get name(): string { return this.vm.name; }
        set name(val: string) { this.vm.name = val; }

        get description(): string | null { return this.vm.description; }
        set description(val: string | null) { this.vm.description = val; }

        handleFormSubmit()
        {
            this.$emit('form-submit', new RevenueEditorFormSubmitEventPayload(this.vm.id, this.name, this.description));
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="revenue-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required minlength="2" maxlength="100" />
                            </div>
                            <div class="form-group">
                                <label>Description:</label>
                                <textarea v-model.trim="description" class="form-control" />
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="revenue-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>